// https://medium.com/@josephat94/building-a-simple-react-hook-to-detect-screen-size-404a867fa2d2
import { useEffect, useState } from 'react';

const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return {
    supportedResolution: screenSize.width >= 700 && screenSize.height >= 200,
    width: screenSize.width,
    height: screenSize.height,
  };
};

export default useScreenSize;
